import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';
import {HhgGlobalUpdateStructure} from '../../features/hhg-rate-global-update/hhg-rate-global-update';

@Injectable({
  providedIn: 'root'
})
export class RateHhgProcureService extends DataService {

  private baseURI = this.apiUri + '/hhgrates/';
  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
  }

  getTheCountOfCurrentDestinations(rateTypeId: number, carrierId: number, sroMasterId: number, originId: number, ratesBidcycleId: number, destinationType: number): Observable<number> {
    this.setUri(this.baseURI + 'currentDestinationCount/' + (null == rateTypeId ? 0 : rateTypeId) + '/' + carrierId + '/'
      + (null == sroMasterId ? 0 : sroMasterId) + '/' + (null == originId ? 0 : originId) + '/' + (ratesBidcycleId === null ? 0 : ratesBidcycleId) + '/' + (destinationType === null ? 0 : destinationType));
    return this.get().pipe(catchError(this.handleError));
  }

  getTheCountOfCurrentOrigins(rateTypeId: number, carrierId: number, sroMasterId: number, destinationId: number, ratesBidcycleId: number, originType: number): Observable<number> {
    this.setUri(this.baseURI + 'currentOriginCount/' + (null == rateTypeId ? 0 : rateTypeId) + '/' + carrierId + '/'
      + (null == sroMasterId ? 0 : sroMasterId) + '/' + (null == destinationId ? 0 : destinationId) + '/' + (ratesBidcycleId === null ? 0 : ratesBidcycleId) + '/' + (originType === null ? 0 : originType));
    return this.get().pipe(catchError(this.handleError));
  }

  getTheCountOfCurrentDestinationsBySroId(rateTypeId: number, carrierId: number, sroMasterId: number, originId: number, ratesBidcycleId: number): Observable<number> {
    this.setUri(this.baseURI + 'currentDestinationCounts/' + (null == rateTypeId ? 0 : rateTypeId) + '/' + carrierId + '/'
      + (null == sroMasterId ? 0 : sroMasterId) + '/' + (null == originId ? 0 : originId) + '/' + (ratesBidcycleId === null ? 0 : ratesBidcycleId));
    return this.get().pipe(catchError(this.handleError));
  }

  getTheCountOfCurrentOriginsBySroId(rateTypeId: number, carrierId: number, sroMasterId: number, destinationId: number, ratesBidcycleId: number): Observable<number> {
    this.setUri(this.baseURI + 'currentOriginCounts/' + (null == rateTypeId ? 0 : rateTypeId) + '/' + carrierId + '/'
      + (null == sroMasterId ? 0 : sroMasterId) + '/' + (null == destinationId ? 0 : destinationId) + '/' + (ratesBidcycleId === null ? 0 : ratesBidcycleId));
    return this.get().pipe(catchError(this.handleError));
  }

  updateRatesHhgProcure(globalEditValues: HhgGlobalUpdateStructure): Observable<any> {
    return this.http.post(this.baseURI + 'globalUpdate/rateshhgprocure', globalEditValues);
  }

}
